<template>
    <div>
        <div class="card pt-0 pt-md-3">
            <div class="card-header ml-0 pb-2 pb-md-3">
                <h4 class = "font-weight-semi-bold">{{ 'tickets' | lang }}</h4>
            </div>
            <div class="card-body mode pt-0">
                <b-tabs content-class="tickets mt-2 mt-md-3" pills>
                    <b-tab :title="'active_tickets_short' | lang" active>
                        <b-list-group v-if="activeTicketsFiltered.length">
                            <item class="pl-0 pr-0" v-for="ticket in activeTicketsFiltered" :key="ticket.id" :ticket="ticket"></item>
                        </b-list-group>
                        <div class="text-center mt-5 mb-5" v-else>
                            <span class = "font-weight-semi-bold">{{ 'buy_tickets_draw' | lang }}</span>
                            <div>
                                <span>{{ 'until_draw_left' | lang }}</span>
                                <countdown :seconds-left="secondsLeft"></countdown>
                                <span>{{ 'minutes_short' | lang }}</span>
                            </div>
                        </div>
                        <div class="text-center" v-if="activeTickets.length > ticketsLimit">
                            <b-button variant="outline-dark" :to="{ name: 'tickets' }" class="font-weight-semi-bold mt-3">{{ 'all_active_tickets' | lang }}</b-button>
                        </div>
                    </b-tab>
                    <b-tab :title="'history' | lang">
                        <b-list-group v-if="ticketsHistoryFiltered.length">
                            <item class="pl-0 pr-0" v-for="ticket in ticketsHistoryFiltered" :key="ticket.id" :ticket="ticket"></item>
                        </b-list-group>
                        <div class="text-center mt-5 mb-5" v-else>
                            <span class = "font-weight-semi-bold">{{ 'empty_history' | lang }}</span>
                            <div>{{ 'winning_chance' | lang }} {{ maxWinAmount | currency }}</div>
                        </div>
                        <div class="text-center">
                            <b-button variant="outline-dark" :to="{ name: 'tickets', params: { gameId } }" class="font-weight-semi-bold mt-3">{{ 'all_history' | lang }}</b-button>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Countdown from '@tv/components/partials/Countdown';
import Item from './Item';

export default {
    components: { Item, Countdown },
    props: ['gameId'],
    data() {
        return {
            ticketsLimit:5
        }
    },
    computed: {
        ...mapGetters(['activeTickets', 'ticketsHistory']),
        ...mapState(['channels', 'purchaseGameId']),

        maxWinAmount() {
            return this.$store.getters.maxWinByGame(this.purchaseGameId);
        },

        secondsLeft() {
            let secondsLeft = 0;
            const channelId = Config.games[this.gameId].channel_id;

            if(!channelId) {
                return;
            }

            const left = this.$store.getters.remaining(channelId);

            if (left > 0) {
                if (secondsLeft == 0 || left < secondsLeft) {
                    secondsLeft = left;
                }
            }

            return secondsLeft;
        },

        game() {
          return Config.games[this.gameId];
        },

        activeTicketsFiltered() {
            return this.activeTickets
                .filter(item => item.game == this.game.name)
                .slice(0, this.ticketsLimit);
        },

        ticketsHistoryFiltered() {
            return this.ticketsHistory
                .filter(item => item.game == this.game.name)
                .slice(0, this.ticketsLimit);
        },
    },
}
</script>